import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PersistentDataService {
  public examReportsPageSize: number | undefined;
  public examReportsSearchString: string | undefined;
  public examSubjectsPageSize: number | undefined;
  public examSubjectsSearchString: string | undefined;
  public examResultsPageSize: number | undefined;
  public examResultsSearchString: string | undefined;
  public examExaminerPageSize: number | undefined;
  public examExaminerSearchString: string | undefined;
  public examAddressPageSize: number | undefined;
  public examAddressSearchString: string | undefined;
  public usersPageSize: number | undefined;
  public usersSearchString: string | undefined;
  public tanentPageSize: number | undefined;
  public tanentSearchString: string | undefined;
}
